import { Component } from '@angular/core';

@Component({
  selector: 'app-ex-recover',
  templateUrl: './ex-recover.component.html',
  styleUrls: ['./ex-recover.component.css']
})
export class ExRecoverComponent {

}
